import { Component, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import { AppWizService } from 'src/app/core/services/app-wiz.service';
import { CertWizService } from 'src/app/core/services/cert-wiz.service';
import { DialogService } from 'src/app/core/services/dailog.service';
import { HttpService } from 'src/app/core/services/http.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { UiStoreService } from 'src/app/core/services/ui-store.service';
import { UserService } from 'src/app/core/services/user.service';
import { UtilService } from 'src/app/core/services/util.service';

@Component({
  selector: 'app-app-wizard-header',
  templateUrl: './app-wizard-header.component.html',
  styleUrls: ['./app-wizard-header.component.scss']
})
export class AppWizardHeaderComponent {

  @Input() isApp = false;
  @Input() addWizObj: any;
  @Input() personalInfo: any;
  @Input() isDialog = false;

  constructor(
    public _utilService: UtilService,
    // private _fb: FormBuilder,
    // public _ui: UiStoreService,
    // public _utilService: UtilService,
    public dialogService: DialogService,
    // public route : ActivatedRoute,
    // public appWizService : AppWizService,
    // public certWizService : CertWizService,
    // public userService: UserService,
    // public ls : LocalStorageService,
    private http: HttpService,
    // private step: MatStepper,
    // public router: Router
  ){ }

  deleteApp(){
    // this._utilService.openMsgDialog('Are you sure you want to delete this application? This action cannot be undone.', 'Disclaimer', true)
    // .afterClosed().subscribe((result) => { 
    //   if(result){
    //     this.appWizService.deleteApp().subscribe(()=>{
    //       this.router.navigate(['app']);
    //     })
    //   }
    // });
  }
  getAppPDFDocId(){
    let doc = this.addWizObj.documents?.find((i:any)=>{
      return i.documentType == "Form" && i.documentSubType == this.addWizObj.approach;
    });
    return doc?.id;
  }
  viewDocument() {
    this.http.get('file', {id: this.getAppPDFDocId()}).subscribe((x:any) => {
      if(x.preSignedURL) {
        this._utilService.urlToBlob(x.preSignedURL, {}, "Application - "+this.addWizObj.appId+".pdf").subscribe();
      }
    });
  }
}
